module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_115_3.6acf5ec9.pdf";